export const containsSqlInjection = (input) => {
    if (!input) return false;

    const sqlInjectionPattern = new RegExp(
        "(" +
        "\\b(ALTER|CREATE|DELETE|DROP|EXEC(UTE)?|INSERT( +INTO)?|MERGE|SELECT|UPDATE|UNION( +ALL)?)\\b" +
        "|" +
        "(['\"][\\s]*OR[\\s]+['\"]?\\d['\"]?[\\s]*=[\\s]*['\"]?\\d['\"]?)" + // ' OR 1=1 gibi basit payloadlar
        "|" +
        "(--[\\s\\S]*)" + // Yorum satırı açma (-- )
        "|" +
        "(\\/\\*[\\s\\S]*\\*\\/)" + // Blok yorum satırı (/* ... */)
        "|" +
        "(;\\s*(ALTER|CREATE|DELETE|DROP|EXEC(UTE)?|INSERT|MERGE|SELECT|UPDATE))" + // Noktalı virgülden sonra tehlikeli komut
        ")",
        "i" // Case insensitive
    );

    return sqlInjectionPattern.test(input);
};

export const sanitizeInputForXSS = (input) => {
    if (!input) return input;
    return input
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#x27;")
        .replace(/\//g, "&#x2F;");
};
